//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import XLSX from "xlsx"; // import xlsx

// import DialogPO from '../components/2021DialogPO'
import cntpo from "../../components/cntPO";

import axios, { CancelToken } from "axios";

export default {
  components: {
    // DialogPO
    cntpo,
  },
  data() {
    return {
      api: `${this.$apiFix}`,
      dialogPO: false,
      so: {},
      export1: {
        dts: "",
        dte: "",
        ws: "",
        we: "",
        wt: {
          label: "Target OTP Week",
          value: "TARGET_BY_RDD"
        }
      },
      export2: {
        dts: "",
        dte: "",
        ws: "",
        we: "",
        wt: {
          label: "Target OTP Week",
          value: "TARGET_BY_RDD"
        }
      },
      dense: true,
      mrd_wk: "",
      rdd_wk: "",
      otif_wk: "",
      totalPage: 1,
      loading: false,
      filter: "",
      dataSO: [],
      cntLate: 0,
      cntAlert: 0,
      cntNormal: 0,
      SoStatus: "ALL",
      grp: "ALL",
      loc: "ALL",
      locs: [],
      POVI: "ALL",
      customer: "",
      customers: [],
      customers_all: [],
      brand: "",
      brands: [],
      brands_all: [],
      gmt: "",
      gmts: [],
      style: "",
      styles: [],
      styles_all: [],
      paginationSO: {
        sortBy: "NEW_RNK",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },
      columnsSO: [{
          name: "SO_NO_DOC",
          field: "SO_NO_DOC",
          label: "SO No. Doc",
          align: "left",
          sortable: true,
        },
        {
          name: "LOC",
          field: "LOC",
          label: "Location",
          align: "left",
          sortable: false,
        },
        {
          name: "SO_DATE",
          field: "SO_DATE",
          label: "SO No. Date",
          align: "left",
          sortable: false,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "TARGET_WK",
          field: "TARGET_WK",
          label: "OTP Wk.",
          align: "left",
          sortable: true,
        },
        {
          name: "RDD_WK",
          field: "RDD_WK",
          label: "RDD Wk.",
          align: "left",
          sortable: true,
        },
        {
          name: "MRD_WK",
          field: "MRD_WK",
          label: "MRD Wk.",
          align: "left",
          sortable: true,
        },
        // {
        //     name: 'FIRST_EDD',
        //     field: 'FIRST_EDD',
        //     label: 'FR Suggest Wk.',
        //     align: 'center',
        //     sortable: true
        // },

        {
          name: "PULL_WK",
          field: "PULL_WK",
          label: "Pull Wk.",
          align: "center",
          sortable: true,
        },
        {
          name: "STYLE_REF",
          field: "STYLE_REF",
          label: "Style",
          align: "left",
          sortable: true,
        },
        {
          name: "CUST_NAME",
          field: "CUST_NAME",
          label: "Customer",
          align: "left",
          sortable: true,
        },
        {
          name: "BRAND_NAME",
          field: "BRAND_NAME",
          label: "Brand",
          align: "left",
          sortable: true,
        },
        // {
        //     name: 'PURCHASER_NAME',
        //     field: 'PURCHASER_NAME',
        //     label: 'Purchaser',
        //     align: 'left',
        //     sortable: true
        // },
        {
          name: "ORDER_QTY",
          field: "ORDER_QTY",
          label: "Pcs.",
          align: "right",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "PO_PENDING",
          field: "PO_PENDING",
          label: "PO Pending",
          align: "right",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "FAB_PO_VI",
          field: "FAB_PO_VI",
          label: "PO VI",
          align: "right",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        }, 
        {
          name: "FAB_PO_NONVI",
          field: "FAB_PO_NONVI",
          label: "PO NON-VI",
          align: "right",
          sortable: true,
          sort: (a, b) => parseInt(a, 10) - parseInt(b, 10),
        },
        {
          name: "DELAY_REASON_NAME",
          field: "DELAY_REASON_NAME",
          label: "DELAY REASON",
          align: "left"
        }
      ],

      // columnsPO: [{
      //         name: 'NEW_RNK',
      //         field: 'NEW_RNK',
      //         label: 'No.',
      //         align: 'left',
      //         sortable: true,
      //         sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
      //     },
      //     {
      //         name: 'PO_NO_DOC',
      //         field: 'PO_NO_DOC',
      //         label: 'PO No.',
      //         align: 'left',
      //         sortable: true
      //     },
      //     {
      //         name: 'DEL_DATE_TXT',
      //         field: 'DEL_DATE_TXT',
      //         label: 'Delivery Date',
      //         align: 'left',
      //         sortable: true,
      //         sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
      //     }, {
      //         name: 'BOMDATE',
      //         field: 'BOMDATE',
      //         label: 'Bom Date',
      //         align: 'left',
      //         sortable: true,
      //         sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
      //     }, {
      //         name: 'SUPPLIER_NAME',
      //         field: 'SUPPLIER_NAME',
      //         label: 'Supplier',
      //         align: 'left',
      //         sortable: true
      //     }, {
      //         name: 'PURCHASER_NAME',
      //         field: 'PURCHASER_NAME',
      //         label: 'purchaser',
      //         align: 'left',
      //         sortable: true
      //     }, {
      //         name: 'SO_NO_DOC',
      //         field: 'SO_NO_DOC',
      //         label: 'Ref. SO No.',
      //         align: 'left',
      //         sortable: true
      //     }, {
      //         name: 'PO_QTY',
      //         field: 'PO_QTY',
      //         label: 'Purchase Qty.',
      //         align: 'right',
      //         sortable: true,
      //         sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
      //     }, {
      //         name: 'REC_QTY',
      //         field: 'REC_QTY',
      //         label: 'Receive Qty.',
      //         align: 'right',
      //         sortable: true,
      //         sort: (a, b) => parseInt(a, 10) - parseInt(b, 10)
      //     }
      // ]
    };
  },
  created() {
    // this.chkAuthen('', '')
    // this.pullData()
    // this.$api = 'http://localhost:9000/nygcontrolroom/' //Develop
    this.LoadFirst();
  },
  watch: {
    SoStatus: function (newValue, oldValue) {
      this.LoadData();
    },
    grp: function (newValue, oldValue) {
      this.loc = "ALL";
      this.LoadData();
    },
    loc: function (newValue, oldValue) {
      this.LoadData();
    },
    POVI: function (newValue, oldValue) {
      this.LoadData();
    },
    customer: function (newValue, oldValue) {
      this.LoadData();
    },
    brand: function (newValue, oldValue) {
      this.LoadData();
    },
    gmt: function (newValue, oldValue) {
      this.LoadData();
    },
    style: function (newValue, oldValue) {
      this.LoadData();
    },
    otif_wk: function (newValue, oldValue) {
      if (this.checkPeriod(newValue) || newValue == "") {
        this.LoadData();
      } else {
        this.ValidWeek();
      }
    },
    rdd_wk: function (newValue, oldValue) {
      if (this.checkPeriod(newValue) || newValue == "") {
        this.LoadData();
      } else {
        this.ValidWeek();
      }
    },
    mrd_wk: function (newValue, oldValue) {
      if (this.checkPeriod(newValue) || newValue == "") {
        this.LoadData();
      } else {
        this.ValidWeek();
      }
    },
  },
  async mounted() {},
  methods: {
    LoadFirst() {
      this.grp = this.$route.params.grp;
      this.loc = this.$route.params.loc;

      this.pulling = setTimeout(() => {
        this.LoadData();
      }, 100);
    },
    LoadData() {
      this.loading = true;
      let params = new FormData();

      params.append("loc", this.loc);
      params.append("viewby", "RDD_W");
      params.append("status", this.SoStatus);
      params.append("grp", this.grp);
      params.append("povi", this.POVI);

      params.append("customer", this.customer);
      params.append("brand", this.brand);
      params.append("gmt", this.gmt);
      params.append("style", this.style);

      params.append("otif_wk", this.otif_wk);
      params.append("rdd_wk", this.rdd_wk);
      params.append("mrd_wk", this.mrd_wk);

      axios({
        method: "post",
        url: this.$apiFix + "2021WipFab.php/wip_so",
        data: params,
      }).then((res) => {
        console.log(res.data);
        this.totalPage = res.data.totalPages;
        this.dataSO = res.data.DataAll;
        this.cntLate = res.data.late;
        this.cntAlert = res.data.alert;
        this.cntNormal = res.data.normal;
        this.locs = res.data.loc;
        this.loading = false;

        this.MasterCustomer();
        this.MasterBrand();
        this.MasterGMT();
        this.MasterStyle();
      });
    },
    checkPeriod(str) {
      var myRe = /[2][0][2-4][0-9](5[0-3]|0[1-9]|[1-4][0-9])/g;
      return myRe.test(str);
    },
    async MasterCustomer() {
      const res = await axios.get(this.$apiFix + "2021WipFab.php/customer", {
        params: {
          loc: this.loc,
          grp: this.grp,
        },
      });
      this.customers = res.data;
      this.customers_all = res.data;
    },

    async MasterBrand() {
      const res = await axios.get(this.$apiFix + "2021WipFab.php/brand", {
        params: {
          loc: this.loc,
          grp: this.grp,
        },
      });
      this.brands = res.data;
      this.brands_all = res.data;
    },

    async MasterGMT() {
      const res = await axios.get(this.$apiFix + "2021WipFab.php/gmt", {
        params: {
          loc: this.loc,
          grp: this.grp,
        },
      });
      this.gmts = res.data;
    },

    async MasterStyle() {
      const res = await axios.get(this.$apiFix + "2021WipFab.php/style", {
        params: {
          loc: this.loc,
          grp: this.grp,
        },
      });
      this.styles_all = res.data;
      this.styles = res.data;
    },

    getLate(obj) {
      if (obj.REC_STATUS == "LATE") {
        return "bg-red-2 text-black";
      } else if (obj.REC_STATUS == "ALERT") {
        return "bg-yellow-2 text-black";
      } else {
        return "bg-green-2 text-black";
      }
    },

    getLateText(obj) {
      if (obj.REC_STATUS == "LATE") {
        return "red-12";
      } else if (obj.REC_STATUS == "ALERT") {
        return "yellow-12";
      } else {
        return "green-12";
      }
    },

    ValidWeek() {
      this.$q.notify({
        position: "top-right",
        timeout: 2500,
        textColor: "white",
        color: "red",
        message: "Format Period is '202034'",
        html: true,
      });
    },

    ExportExcelSODate() {
      window.open(
        `${this.$apiflask}exp_ppr_fab/${this.grp}/${this.export1.dts}/${this.export1.dte}/${this.create_UUID()}`,
        `_export`
      );
    },

    ExportExcelSOWeek() {
      window.open(
        `${this.$apiflask}exp_ppr_fab_wk/${this.grp}/${this.export1.ws}/${this.export1.we}/${this.create_UUID()}/${this.export1.wt.value}`,
        `_export`
      );
    },

    ExportExcelPODate() {
      window.open(
        `${this.$apiflask}exp_ppr_fab_po/${this.grp}/${this.export2.dts}/${this.export2.dte}/${this.create_UUID()}`,
        `_export`
      );
    },

    ExportExcelPOWeek() {
      window.open(
        `${this.$apiflask}exp_ppr_fab_wk_po/${this.grp}/${this.export2.ws}/${this.export2.we}/${this.create_UUID()}/${this.export2.wt.value}`,
        `_export`
      );
    },

    ExportExcelPO() {
      let params = new FormData();
      params.append("dts", this.dts);
      params.append("dte", this.dte);
      params.append("grp", this.grp);
      axios
        .post(`${this.$apiFix}export.php/po_fabric`, params)
        .then((response) => {
          //   console.log(response.data);
          const dataWS = XLSX.utils.json_to_sheet(response.data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, `export-PO-FABRIC-${this.grp}-${this.create_UUID()}.xlsx`);
        })
        .catch((err) => {
          console.error(err);
        });
    },

    filterFnStyle(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.styles = this.styles_all.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterFnCustomer(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.customers = this.customers_all.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterFnBrand(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.brands = this.brands_all.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    OpenDialogPO(so) {
      this.so = so;
      this.dialogPO = true;
    },
    ClosedDialogPO(value) {
      this.dialogPO = false;
    },
  },
};
